import {
    Group
} from 'three';
import { Component3D } from './Component3D';
import Text3D from './Text3D';
import { /* SIZE_REFS_MAP, */ SIZE_OPTIONS, SIZE_REFS_MAP } from '../../../constants/sizes';
import { COLOR_DEFAULT_TEXT } from '../../../constants/colors';
import {
    getTextLayoutStyle,
    getTextMetrics,
    getTitleMetrics
} from './metrics/DefaultTextBlockMetrics';

export class TextBlock extends Component3D {
    #title = '';
    #text = '';
    _textG;
    _title3d;
    _text3d;

    constructor(title, text) {
        super();

        const textG = new Group();

        this.add(textG);

        this.#title = title;
        this.#text = text;
        this._textG = textG;
    }

    _setup() {
        super._setup();
        this.waitForPreload = true;
        this.hasResize = true;
    }

    _resize(winWidth, winHeight, orientation, orientationChanged, changed, pixelRatio) {
        super._resize(winWidth, winHeight, orientation, orientationChanged, changed, pixelRatio);

        if (changed) {
            if (this._title3d) {
                const metricsTtl = getTitleMetrics(orientation);
                const metricsTxt = getTextMetrics(orientation);

                this._title3d.setMetrics({
                    ...metricsTtl
                });
                this._text3d.setMetrics({
                    ...metricsTxt
                });

                this._updateTextPosition(orientation);
            }
        }
    }

    setupPreloadedContent(infrastructure) {
        const metricsTtl = getTitleMetrics(SIZE_OPTIONS.LANDSCAPE);
        const metricsTxt = getTextMetrics(SIZE_OPTIONS.LANDSCAPE);

        const title3d = new Text3D({
            ...metricsTtl,
            color: COLOR_DEFAULT_TEXT,
            valign: 'top'
        }, this.#title, infrastructure);

        const text3d = new Text3D({
            ...metricsTxt,
            color: COLOR_DEFAULT_TEXT,
            valign: 'center'
        }, this.#text, infrastructure);

        this._textG.add(title3d);
        this._textG.add(text3d);

        this._title3d = title3d;
        this._text3d = text3d;

        this._updateTextPosition(SIZE_OPTIONS.LANDSCAPE);
    }

    _updateTextPosition(orientation) {
        const { numLines, marginBottom } = getTextLayoutStyle(orientation);
        const { shiftYTextBlockNumLines } = SIZE_REFS_MAP[orientation];

        this._text3d.position.y = -this._text3d.lineHeight * shiftYTextBlockNumLines;
        let y = this._text3d.position.y + this._text3d.textHeight * 0.5;

        if (numLines === 'auto') {
            y += this._title3d.textHeight;
            y += this._title3d.lineHeight * marginBottom;
        } else {
            y += this._title3d.lineHeight * (numLines + marginBottom);
        }
        this._title3d.position.y = y;
    }
}
